/**
 * Tells S3 to serve the object under the name we store. Browsers ignore a
 * `download` attribute on a cross-origin link, so without this header the saved
 * file takes its name from the S3 key and a rename never reaches the user.
 *
 * `filename*` with UTF-8 carries accents and spaces, which plain `filename`
 * cannot.
 */
export const contentDispositionFor = (
  fileName: string | string[] | undefined
): { ResponseContentDisposition?: string } => {
  if (typeof fileName !== 'string' || !fileName) {
    return {};
  }

  return {
    ResponseContentDisposition: `attachment; filename*=UTF-8''${encodeURIComponent(fileName)}`,
  };
};
